/* 페르소나 설정 원문 파싱 — 레퍼런스 screens2.js personaRows/personaBody.
   원문은 `라벨: 값` 줄이 이어진 형식이고, 한 줄에 `나이: 22세 / 성별: 남`처럼 두 항목이 들어오기도 한다. */

type PersonaRow = { k: string; v: string }

/** 값이 짧아 칩으로 묶는 항목 */
export const PERSONA_META = /^(이름|나이|성별)$/
/** 시작 전에 읽을 이유가 없는 게임 규칙이라 접어 두는 항목 */
export const PERSONA_FOLD = /^(능력|제약)$/

export function personaRows(desc: string): PersonaRow[] {
  const rows: PersonaRow[] = []
  for (const line of String(desc || '').split('\n')) {
    line
      .trim()
      .split(' / ')
      .forEach((segment, i) => {
        const seg = segment.trim()
        if (!seg) return
        const m = seg.match(/^([^:：]{1,6})[:：]\s*(.+)$/)
        if (m) rows.push({ k: m[1].trim(), v: m[2] })
        // 라벨이 없으면 값 안에 있던 슬래시다 — 앞 행에 되돌린다
        else if (i && rows.length) rows[rows.length - 1].v += ' / ' + seg
        else rows.push({ k: '', v: seg })
      })
  }
  return rows
}

/** 저장된 페르소나 → 대화에 전달하는 설정 문장 (v2-account desc()) */
export const PERSONA_GENDERS = [
  '설정 안 함',
  '여성',
  '남성',
  '논바이너리',
] as const

export function savedPersonaDesc(p: {
  age?: string
  role?: string
  appearance?: string
  personality?: string
  description?: string
}) {
  return [
    p.age ? `나이: ${p.age}` : '',
    p.role ? `역할: ${p.role}` : '',
    p.appearance ? `외형: ${p.appearance}` : '',
    p.personality ? `성격: ${p.personality}` : '',
    p.description || '',
  ]
    .filter(Boolean)
    .join('\n')
}

export function personaText(p: {
  name: string
  gender: string
  desc: string
}): string {
  return [p.name, p.gender, p.desc].join(' · ')
}

export function parsePersonaText(
  value: string,
  defaultName: string
): { name: string; gender: string; desc: string } {
  const pieces = value.split(' · ')
  return {
    name: pieces.length > 1 ? pieces.shift() || defaultName : defaultName,
    gender: pieces.length > 1 ? pieces.shift() || '설정 안 함' : '설정 안 함',
    desc: pieces.join(' · '),
  }
}
